import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=6fc0fa54&scoped=true"
import script from "./updateDialog.vue?vue&type=script&lang=js"
export * from "./updateDialog.vue?vue&type=script&lang=js"
import style0 from "./updateDialog.vue?vue&type=style&index=0&id=6fc0fa54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0fa54",
  null
  
)

export default component.exports